import { createSelector } from 'reselect'
import { pageCacheIdentity, pageCacheKey } from './utils/contactsPageCache'

export const selectContactsToolsState = state => state.contactsTools

export const selectContactsItems = createSelector(
  selectContactsToolsState,
  data => data.items
)

export const selectContactsPaginator = createSelector(
  selectContactsToolsState,
  data => data.paginator
)

export const selectContactsQuery = createSelector(
  selectContactsToolsState,
  data => data.query
)

export const selectContactsCursor = createSelector(
  selectContactsToolsState,
  data => data.cursor
)

export const selectContactsCountry = createSelector(
  selectContactsToolsState,
  data => data.country
)

export const selectContactsOnlyWithContracts = createSelector(
  selectContactsToolsState,
  data => data.onlyWithContracts
)

export const selectContactsIsLoading = createSelector(
  selectContactsToolsState,
  data => data.isLoading
)

export const selectContactsError = createSelector(
  selectContactsToolsState,
  data => data.error
)

export const selectContactsActionLoadingKey = createSelector(
  selectContactsToolsState,
  data => data.actionLoadingKey
)

export const selectContactsHasSearched = createSelector(
  selectContactsToolsState,
  data => data.hasSearched
)

export const selectContactsLastActionAtByContractId = createSelector(
  selectContactsToolsState,
  data => data.lastActionAtByContractId || {}
)

export const selectContactsCachedPage = createSelector(
  selectContactsToolsState,
  data => {
    if (data.pagesKey !== pageCacheIdentity(data)) return null

    return data.pages?.[pageCacheKey(data.cursor)] ?? null
  }
)
